import { useState, useCallback } from 'react';
import { makeStyles, tokens, Button } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import { DiagnosticDashboard, BlindSpotListView, BlindSpotDetailDrawer } from '../features/diagnostic';
import { PageHeader } from '../components/common/PageHeader';
import type { RuntimeBlindSpot } from '../types';

type DiagnosticView = 'dashboard' | 'blindSpots';

const useStyles = makeStyles({
  page: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXXL,
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    gap: tokens.spacingHorizontalM,
  },
});

export function DiagnosticPage() {
  const styles = useStyles();
  const [view, setView] = useState<DiagnosticView>('dashboard');
  const [selectedBlindSpot, setSelectedBlindSpot] = useState<RuntimeBlindSpot | null>(null);

  const handleViewBlindSpots = useCallback(() => {
    setView('blindSpots');
  }, []);

  const handleBack = useCallback(() => {
    setView('dashboard');
    setSelectedBlindSpot(null);
  }, []);

  const handleSelectBlindSpot = useCallback((blindSpot: RuntimeBlindSpot) => {
    setSelectedBlindSpot(blindSpot);
  }, []);

  const handleCloseDrawer = useCallback(() => {
    setSelectedBlindSpot(null);
  }, []);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        {view === 'blindSpots' && (
          <Button appearance="subtle" icon={<ArrowLeftRegular />} onClick={handleBack}>
            Back
          </Button>
        )}
        <PageHeader
          title={view === 'dashboard' ? 'Delivery Governance Diagnostic' : 'Runtime Blind Spots'}
          subtitle="Identify ungoverned areas in your delivery pipeline and infrastructure"
        />
      </div>

      {view === 'dashboard' ? (
        <DiagnosticDashboard onViewBlindSpots={handleViewBlindSpots} />
      ) : (
        <BlindSpotListView onSelectBlindSpot={handleSelectBlindSpot} />
      )}

      <BlindSpotDetailDrawer
        blindSpot={selectedBlindSpot}
        open={selectedBlindSpot !== null}
        onClose={handleCloseDrawer}
      />
    </div>
  );
}
